import { Component } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { ErrorService } from '@kv-common-components/kv-common-components';
import { I18nPipe } from '@shared/pipes/i18n.pipe';
import { modalAnimations } from '@shared/animations/animations';
import * as moment from 'moment';

@Component({
    selector: 'app-error-modal-component',
    templateUrl: './error-modal.component.html',
    styleUrls: [],
    animations: modalAnimations,
})
export class ErrorModalComponent {
    title: string;
    closebutton: string;
    errorMessage: string;
    errorCodeMessage: string;
    private defaultErrorMessage =
        'Nous vous invitons à réessayer ultérieurement.';

    constructor(
        private errorService: ErrorService,
        private i18nPipe: I18nPipe,
        private logger: NGXLogger
    ) {
        this.errorService.getError().subscribe((errorData) => {
            this.getErrorMessage(errorData);
        });
    }
    getErrorMessage(error: any) {
        if (error) {
            this.logger.trace('Received error : ', error);
            this.setDefaultValues();

            if (this.i18nPipe.i18nData) {
                let finalError = error;
                if (finalError.error) {
                    finalError = finalError.error;
                }
                this.getFunctionnalError(finalError);
                this.getTechnicalError(finalError);
            }
        }
    }
    close() {
        this.errorMessage = null;
    }
    setDefaultValues() {
        this.logger.trace('Setting default error message');
        if (this.i18nPipe.i18nData) {
            this.title = this.i18nPipe.transform('global.popin.error.title');
            this.errorMessage = this.i18nPipe.transform('ws.error.unknown');
            this.closebutton = this.i18nPipe.transform('global.close');
        } else {
            this.title = 'Une erreur est survenue';
            this.errorMessage = this.defaultErrorMessage;
            this.closebutton = 'Fermer';
        }
    }

    private getFunctionnalError(error: any): void {
        if (error.erreursFonctionnelle && error.erreursFonctionnelle[0]) {
            const errorMessage = (
                this.i18nPipe.transform(
                    `ws.error.${error.erreursFonctionnelle[0].code.toString()}`
                ) || this.defaultErrorMessage
            )
                // filter error code at the end of the message
                .replace(/<[a-zA-z0-9_]*>/, '')
                .trim();
            if (errorMessage) {
                this.errorMessage = errorMessage;
            }
            this.getErrorCodeMessage(error.erreursFonctionnelle[0]);
        }
    }

    private getErrorCodeMessage(erreurFonctionnelle: any) {
        if (erreurFonctionnelle.code) {
            const currentDate = moment(new Date()).format('DD-MM-YYYY HH:MM:SS');
            this.errorCodeMessage =
            'CODE ERREUR : ' +
            erreurFonctionnelle.code.toString() +
            ' (' +
            currentDate +
            ')';
        }
    }

    private getTechnicalError(error: any): void {
        if (error.code && error.code === 401) {
            const errorMessage = this.i18nPipe.transform(
                'ws.error.401.badInfo'
            );
            if (errorMessage) {
                this.errorMessage = errorMessage;
            }
        }
    }
}
